import { isSameId } from "../../helpers";
export default function (store, { cardId, id, comment }) {
    if (cardId) {
        const state = store.getState();
        const commentId = id || comment.id;
        const commentCard = cardId || comment.cardId;
        if (!commentId || !commentCard) {
            return;
        }
        let originalComment = {};
        const cards = state.cards.map(c => {
            if (isSameId(c.id, commentCard)) {
                return {
                    ...c,
                    comments: (c.comments || []).map(c => {
                        if (isSameId(c.id, commentId)) {
                            originalComment = { ...c };
                            return { ...c, ...comment };
                        }
                        return c;
                    }),
                };
            }
            return c;
        });
        store.setState({ cards });
        return () => {
            store.in.exec("update-comment", {
                id: commentId,
                cardId: commentCard,
                comment: originalComment,
                $meta: { skipHistory: true },
            });
        };
    }
}
//# sourceMappingURL=update.js.map